<template>
    <div class="body">
        <header class="header-section">
            <h1 class="main-title">10月热门课程</h1>
            <h1 class="main-title">🔥看见成长的方向</h1>
            <div class="subtitle-wrapper">
                <span class="subtitle-badge">破局</span>
                <span class="subtitle-badge">蓄力</span>
                <span class="subtitle-badge">蜕变</span>
            </div>
        </header>
        <div class="wrapper">
            <div class="course-section">
                <div class="course-grid">
                    <label v-for="(item, index) in topRecommendLink" :key="'hot-' + index"
                        :class="['course-item', { 'is-active': selectedCourses.includes(item.Name) }]">
                        <input type="checkbox" :value="item.Name" v-model="selectedCourses" />
                        <span class="check-mark"></span>
                        <span class="course-name">{{ item.Name }}</span>
                    </label>
                </div>
            </div>
        </div>
        <!-- <div class="compulsory-section" v-if="coc && coc.length > 0">
            <h3 class="compulsory-title">必修课程完成情况：</h3>
            <div class="compulsory-grid">
                <div v-for="(item, index) in coc" :key="index" class="compulsory-card">
                    <span class="compulsory-name">{{ item.Name }}</span>
                    <span :class="['status-badge', item.iscompleted ? 'status-done' : 'status-todo']">
                        {{ item.iscompleted ? '已完成' : '未完成' }}
                    </span>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    props: {
        ReportData: { type: Object, required: false },
        selected: { type: Array, default: () => [] }
    },
    data() {
        return {
            topRecommendLink: [],
            selectedCourses: [],
            // coc: [],
        }
    },
    created() {
        if (this.ReportData) {
            this.topRecommendLink = JSON.parse(this.ReportData.topRecommendLink || '[]');
        }
        // if (this.ReportData.coc !== null) {
        //     this.coc = JSON.parse(this.ReportData.coc)
        //     // console.log(this.coc,'coc')
        // }
    },
    watch: {
        selectedCourses: {
            deep: true,
            handler(newVal) {
                this.$emit('update:selected', newVal);
            }
        }
    },
    mounted() {
        this.selectedCourses = [...this.selected];
    }
}
</script>

<style scoped>
/* 年度报告风格 · 深色热门课程 + 必修课页（橙金调） */
.body {
    position: relative;
    background:
        url("../../assets/26June/logo.png") right top no-repeat,
        url("../../assets/26October/bg.png") no-repeat center / cover;
    background-size: 100px 32px, cover;
    background-color: #1a0810;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    color: #2d1505;
    box-sizing: border-box;
    padding: 20px 0;
    text-shadow: 0 0 3px rgba(255, 240, 210, 0.5), 0 1px 2px rgba(255, 240, 210, 0.3);
}

.body * {
    text-shadow: 0 0 3px rgba(255, 240, 210, 0.5), 0 1px 2px rgba(255, 240, 210, 0.3);
}

/* 头部 */
.header-section {
    position: relative;
    z-index: 2;
    padding-top: 8vh;
    text-align: center;
    margin-bottom: 16px;
}

.main-title {
    font-size: 25px;
    color: #db6018;
    text-shadow: 
    -1.5px -1.5px 0 #fff,  
     1.5px -1.5px 0 #fff,
    -1.5px  1.5px 0 #fff,
     1.5px  1.5px 0 #fff;
    margin: 0;
    font-weight: 800;
    letter-spacing: 2px;
}

/* .main-title:first-child {
    background: linear-gradient(180deg, #7cc8ff, #4a9eff 60%, #2d7dd6);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.6));
    margin-bottom: 4px;
} */

.subtitle-wrapper {
    margin-top: 10px;
    display: flex;
    gap: 10px;
    justify-content: center;
}

.subtitle-badge {
    font-size: 15px;
    background: rgba(242, 214, 137, 0.4);
    border: 1px solid rgba(224, 115, 25, 0.35);
    color: #863d06;
    font-weight: 700;
    padding: 3px 12px;
    border-radius: 20px;
    letter-spacing: 1px;
}

/* 引用卡片（模板中暂未使用，保留适配） */
.quote-card {
    position: relative;
    z-index: 2;
    width: 88%;
    background: rgba(255, 245, 230, 0.15);
    border: 1px solid rgba(80, 40, 15, 0.2);
    border-left: 3px solid #379de7;
    padding: 14px 16px;
    margin-bottom: 18px;
    border-radius: 14px;
}

.p-highlight {
    font-weight: 700;
    color: #7cc8ff;
    margin: 0 0 5px 0;
}

.p-content {
    font-size: 13.5px;
    color: rgba(45, 20, 5, 0.85);
    line-height: 1.5;
}

/* 课程列表区域 */
.wrapper {
    position: relative;
    z-index: 2;
    width: 90%;
    margin: 0 auto;
}

.course-section {
    background: transparent;
    border-radius: 16px;
}

/* 交互式课程项 */
.course-grid {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.course-item {
    display: flex;
    align-items: center;
    padding: 15px 16px;
    background: rgba(236, 237, 239, 0.55);
    border: 1.5px solid rgba(80, 40, 15, 0.2);
    border-radius: 14px;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    cursor: pointer;
    position: relative;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.course-item input {
    position: absolute;
    opacity: 0;
}

.check-mark {
    width: 20px;
    height: 20px;
    border: 2px solid rgba(14, 14, 14, 0.3);
    border-radius: 50%;
    margin-right: 12px;
    position: relative;
    transition: all 0.3s;
    flex-shrink: 0;
}

.course-item:active {
    transform: scale(0.97);
}

.course-item.is-active {
    border-color: rgba(74, 158, 255, 0.75);
    background: rgba(74, 158, 255, 0.1);
    box-shadow: 0 8px 24px rgba(74, 158, 255, 0.16), inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.course-item.is-active .check-mark {
    background: linear-gradient(135deg, #a8d8ff, #2d7dd6);
    border-color: #4a9eff;
    box-shadow: 0 0 10px rgba(74, 158, 255, 0.6);
}

.course-item.is-active .check-mark::after {
    content: '✓';
    color: #ffffff;
    font-weight: 900;
    position: absolute;
    left: 3px;
    top: -2px;
    font-size: 14px;
}

.course-name {
    font-size: 15px;
    font-weight: 500;
    color: rgba(45, 20, 5, 0.85);
    letter-spacing: 0.5px;
}

/* 打钩动画 */
.course-item.is-active .check-mark::after {
    animation: popIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes popIn {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

/* 必修课程外层大容器 */
.compulsory-section {
    position: relative;
    z-index: 2;
    width: 88%;
    margin: 3vh auto 0 auto;
}

/* 标题 */
.compulsory-title {
    font-size: 15px;
    font-weight: 800;
    color: #7cc8ff;
    margin: 0 0 12px 0;
    padding-left: 4px;
    letter-spacing: 1px;
}

/* 课程卡片网格 */
.compulsory-grid {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

/* 单个必修课程卡片 */
.compulsory-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(255, 245, 230, 0.15);
    border: 1px solid rgba(80, 40, 15, 0.2);
    padding: 13px 16px;
    border-radius: 14px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.compulsory-card:active,
.compulsory-card:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-1px);
    border-color: rgba(74, 158, 255, 0.35);
}

/* 课程名 */
.compulsory-name {
    font-size: 14px;
    font-weight: 600;
    color: rgba(45, 20, 5, 0.85);
    flex: 1;
    padding-right: 15px;
    line-height: 1.4;
}

/* 状态标签胶囊 */
.status-badge {
    font-size: 12px;
    font-weight: 700;
    padding: 4px 12px;
    border-radius: 30px;
    letter-spacing: 0.5px;
    flex-shrink: 0;
}

/* 已完成：翡翠青 */
.status-done {
    background: rgba(94, 234, 212, 0.14);
    color: #18bc20;
    border: 1px solid rgba(94, 234, 212, 0.35);
}

/* 未完成：柔和红 */
.status-todo {
    background: rgba(248, 113, 113, 0.12);
    color: #c22626;
    border: 1px solid rgba(248, 113, 113, 0.3);
}

/* PC 宽屏适配 */
@media screen and (min-width: 786px) {
    .body {
       background:
            url("../../assets/26June/logo.png") right top no-repeat,
            url("../../assets/26October/pcbg.png") no-repeat center / cover;
        background-size: 110px 35px, cover;
        width: 100% !important;
        height: 100vh !important;
        padding: 60px 10%;
        border-radius: 0 !important;
        box-shadow: none !important;
        border: none !important;
    }
    .main-title {
        font-size: 32px;
    }
    .subtitle-badge {
        font-size: 20px;
    }
    .course-name {
        font-size: 20px;
    }
    .compulsory-section {
        width: 600px;
    }

    .compulsory-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
    }

    .quote-card,
    .wrapper {
        width: 600px;
    }

    .course-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 15px;
    }
}
</style>